import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import { connect } from 'react-redux'
import iconNew from '../../../assets/icons/new-light.svg'
import Pagination from '../../../components/pagination/pagination.component'
import './salepoints.styles.scss'
import Service from './salepoints.service'
import iconDelete from '../../../assets/icons/delete-red.svg'
import iconEdit from '../../../assets/icons/edit-dark.svg'
import DeleteSalePoint from './components/delete/delete.component'

class SalePoints extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        this.service.loadSalepoints()
    }

    onPageChange = page => {
        this.setState({
            ...this.state,
            currentPage: page
        }, () => this.service.loadSalepoints())
    }

    onFilterChange = e => {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                value: "",
                [e.target.name]: e.target.value
            }
        })
    }

    onFilterSubmit = e => {
        e.preventDefault()
        this.service.loadSalepoints()
    }

    toggleShowDelete = salePoint => this.setState({
        ...this.state,
        showDelete: !this.state.showDelete,
        salePointToDelete: salePoint
    })

    onDelete = () => this.setState({
        ...this.state,
        showDelete: false,
        salepoints: this.state.salepoints.filter(salePoint => salePoint.id !== this.state.salePointToDelete.id)
    })

    getTypeLabel = status => {
        switch(status){
            case 1:
                return "Instant Access"
            case 2:
                return "Prepaid"
            default:
                return "Unknown"
        }
    }

    render() {
        return (
            <>
                {this.state.loading && <Dialog><Loading /></Dialog>}
                {this.state.showDelete && <Dialog><DeleteSalePoint salePoint={this.state.salePointToDelete} onDelete={this.onDelete} onCancel={() => this.toggleShowDelete(null)} /></Dialog>}
                <div className="salepoints">
                    <div className="header">
                        <h4>SalePoints</h4>
                        <div className="buttons">
                            <Link className="btn" to="/internet/salepoints/create"><img alt="" src={iconNew} />New Salepoint</Link>
                        </div>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Phone</th>
                                <th>SMS Sender</th>
                                <th>Address</th>
                                <th>City</th>
                                <th>Location</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.salepoints.map((salepoint, key) => <tr key={key}>
                                    <td>{salepoint.name}</td>
                                    <td>{this.getTypeLabel(salepoint.type)}</td>
                                    <td>{salepoint.phone}</td>
                                    <td>{salepoint.smsSender}</td>
                                    <td>{salepoint.address}</td>
                                    <td>{salepoint.city}</td>
                                    <td>{salepoint.location.name}</td>
                                    <td>
                                        <div className="actions">
                                            <img alt="" src={iconEdit} onClick={() => this.props.history.push('/internet/salepoints/' + salepoint.id)} />
                                            <img alt="" src={iconDelete} onClick={() => this.toggleShowDelete(salepoint)} />
                                        </div>
                                    </td>
                                </tr>)
                            }
                        </tbody>
                    </table>
                    {
                        this.state.total > 0 && <Pagination totalItemsCount={this.state.total} currentIndex={this.state.currentPage} itemsPerPage={this.state.pageSize} onChange={this.onPageChange} />
                    }
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(SalePoints))